import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ViewsComponent } from './views/views.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./views/views.module').then(m => m.ViewsModule) },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true,enableTracing:true}),],
  exports: [RouterModule]
})
export class AppRoutingModule { }
